import { c as _c } from "react/compiler-runtime";
import { useMutation } from "@tanstack/react-query";
import { useCallback } from "react";
import type { SerializedPythonArg } from "../lib/createPythonRuntimeArgs";
import { pythonRunner } from "../lib/pythonRunner";
import type { ExecutionResult } from "./useCodeExecution";
export const usePythonCodeRunner = () => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    mutateAsync: executePythonCode,
    isPending
  } = useMutation(t0);
  let t1;
  if ($[1] !== executePythonCode) {
    t1 = async (codeInput_0, args_0) => await executePythonCode({
      codeInput: codeInput_0,
      args: args_0
    });
    $[1] = executePythonCode;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const runPythonCode = t1;
  let t2;
  if ($[3] !== isPending || $[4] !== runPythonCode) {
    t2 = {
      runPythonCode,
      isProcessing: isPending
    };
    $[3] = isPending;
    $[4] = runPythonCode;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
async function _temp(t0) {
  const {
    codeInput,
    args
  } = t0;
  return pythonRunner.run(codeInput, undefined, args);
}